import Service from "../../AuthService";
const MaterialImport = {
    getMaterialImport(page) {
        return Service.get("/material-import?page="+page);
    },
    showMaterialImport(id) {
        return Service.get("/material-import/" + id);
    },
    updateMaterialImport(id, data) {
        return Service.put("/material-import/" + id, data);
    },
    createMaterialImport(data) {
        return Service.post("/material-import", data);
    },
    deleteMaterialImport(id) {
        return Service.delete("/material-import/" + id);
    },
    searchMaterialImport(page,code, date) {
        return Service.post(
            "/search-material-import?page="+page+"&code=" + code + "&date=" + date
        );
    }
};
export default MaterialImport;
